import { MessageCircle, Phone, MapPin, Clock, Navigation } from "lucide-react";
import {
  WHATSAPP_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
  MAPS_URL,
} from "../../i18n/translations";

export const Contact = ({ t }) => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-zinc-950 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="overline">{t.contact.overline}</span>
            <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
              {t.contact.title}
            </h2>
            <p className="font-body mt-6 text-zinc-400 text-base md:text-lg max-w-md leading-relaxed">
              {t.contact.subtitle}
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                data-testid="contact-whatsapp-cta"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-zinc-950 font-body font-bold text-sm tracking-wider uppercase px-6 py-4 transition-colors"
              >
                <MessageCircle className="w-4 h-4" strokeWidth={2.6} />
                {t.contact.cta_whatsapp}
              </a>
              <a
                data-testid="contact-call-cta"
                href={`tel:${PHONE_TEL}`}
                className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-zinc-50 text-zinc-50 font-body font-bold text-sm tracking-wider uppercase px-6 py-4 transition-colors"
              >
                <Phone className="w-4 h-4" strokeWidth={2.4} />
                {t.contact.cta_call}
              </a>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
            <div className="bg-zinc-950 p-7 md:p-8">
              <MapPin className="w-5 h-5 text-red-600 mb-5" strokeWidth={1.8} />
              <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500">
                {t.contact.address_label}
              </span>
              <p className="font-heading mt-3 text-lg md:text-xl text-zinc-100 leading-snug whitespace-pre-line">
                {t.contact.address}
              </p>
              <a
                data-testid="contact-directions-cta"
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="link-anim mt-5 inline-flex items-center gap-2 font-body text-sm font-semibold text-red-600"
              >
                <Navigation className="w-3.5 h-3.5" strokeWidth={2.4} />
                {t.contact.cta_directions}
              </a>
            </div>

            <div className="bg-zinc-950 p-7 md:p-8">
              <Phone className="w-5 h-5 text-red-600 mb-5" strokeWidth={1.8} />
              <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500">
                {t.contact.phone_label}
              </span>
              <a
                href={`tel:${PHONE_TEL}`}
                className="block font-heading mt-3 text-2xl md:text-3xl font-bold tracking-tight text-zinc-50 hover:text-red-600 transition-colors"
              >
                {PHONE_DISPLAY}
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="link-anim mt-5 inline-flex items-center gap-2 font-body text-sm font-semibold text-red-600"
              >
                <MessageCircle className="w-3.5 h-3.5" strokeWidth={2.4} />
                WhatsApp
              </a>
            </div>

            <div className="bg-zinc-950 p-7 md:p-8 sm:col-span-2">
              <Clock className="w-5 h-5 text-red-600 mb-5" strokeWidth={1.8} />
              <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500">
                {t.contact.hours_label}
              </span>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <p className="font-body text-sm text-zinc-500">
                    {t.contact.hours_weekdays}
                  </p>
                  <p className="font-heading text-lg font-medium text-zinc-100 mt-1">
                    08:30 – 13:00
                  </p>
                  <p className="font-heading text-lg font-medium text-zinc-100">
                    15:00 – 18:30
                  </p>
                </div>
                <div>
                  <p className="font-body text-sm text-zinc-500">
                    {t.contact.hours_weekend}
                  </p>
                  <p className="font-heading text-lg font-medium text-zinc-500 mt-1">
                    {t.contact.hours_closed}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map */}
        <div
          data-testid="map-embed"
          className="mt-16 border border-zinc-800 overflow-hidden h-[360px] md:h-[440px]"
        >
          <iframe
            title="T-CARS Garage location"
            src="https://www.google.com/maps?q=Cami+de+Can+Guasch+5+Parets+del+Valles&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0, filter: "grayscale(1) invert(0.92) contrast(0.85)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};
